import { render, staticRenderFns } from "./MinG.vue?vue&type=template&id=d014b0e4&scoped=true&"
import script from "./MinG.vue?vue&type=script&lang=js&"
export * from "./MinG.vue?vue&type=script&lang=js&"
import style0 from "./MinG.vue?vue&type=style&index=0&id=d014b0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d014b0e4",
  null
  
)

export default component.exports